import ReactGA from "react-ga4";
import { AppProvider } from "@shopify/polaris";
import translations from "@shopify/polaris/locales/en.json";
import { RouterProvider } from "@tanstack/react-router";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import { initStore } from "./app/_state/store";
import { router } from "./router";

import "rsuite/dist/rsuite.min.css";
import { loadWebVitals } from "./utils/loadWebVitals";
import config from "@vendor-app/config";

initializeGA();
loadWebVitals();

function App() {
  return (
    <Provider store={initStore()}>
      <AppProvider i18n={translations}>
        <RouterProvider router={router} />
      </AppProvider>
    </Provider>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

function initializeGA() {
  const measurementId = config.googleAnalytics.measurementId;
  if (!measurementId || measurementId === "G-") {
    return;
  }
  ReactGA.initialize(measurementId);
}
